<div class="filters">
  <div class="filter-header" [ngClass]="classFlag ? 'headerFilter' : ''">
    <div>
      @if (dateSelected) {
        <span>
          <div class="back-button" (click)="back()"></div>
          <!-- <img src="../../../../assets/images/back.svg" class="iconClass" (click)="back()" /> -->
        </span>
      }
    </div>
    <div class="report-generation-txt" [ngClass]="classFlag ? 'apply' : ''">
      Report Generation
    </div>
    <div>
      <div class="close-button" (click)="close()"></div>
      <!-- <img src="assets/images/close-circle.svg"  class="cursor-pointer close" alt="" /> -->
    </div>
  </div>
  @if (!dateSelected && data != 'History' && data != 'Seperate') {
    <div class="select">
      <mat-select [(value)]="selected" placeholder="Select Date Type" class="selectClass"
        (selectionChange)="dateType($event)">
        <mat-option value="Created Date" class="option">Created Date</mat-option>
        <mat-option value="Updated Date" class="option">Updated Date</mat-option>
        @if (data != 'History') {
          <mat-option value="Onboarded Date" class="option">Onboarding Date</mat-option>
        }
      </mat-select>
    </div>
  }
  @if (dateSelected || data == 'History' || data == 'Seperate') {
    <div class="row background">
      <div class="col-md-6 firstCol">
        <img src="../../../../assets/images/report-img.svg" />
      </div>
      <div class="col-md-6 secondCol">
        @if (dateSelected || data == 'History' || data == 'Seperate') {
          <form class="user-form" [formGroup]="filterForm"
            (submit)="onSubmit()" autocomplete="off">
            <div class="row mt-20">
              <div class="col-sm-12 form-group"
                [ngClass]="classFlag ? 'breakPoint' : ''">
                <label name="date" class="dateLabel">Date</label>
                <mat-form-field class="date-picker">
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate placeholder="Start date" [value]="startDates"
                      (dateChange)="startDateChange($event)" />
                      <input matEndDate placeholder="End date" [value]="endDates" (dateChange)="endDateChange($event)" />
                    </mat-date-range-input>
                    <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker">
                    </mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                  </mat-form-field>
                </div>
                @if (data != 'Seperate') {
                  <div class="col-sm-12 form-group"
                    [ngClass]="classFlag ? 'breakPoint' : ''">
                    <label name="role">Vendors</label>
                    <mat-select disableRipple placeholder="Select Vendor" class="selectClass" value="selectedVendor"
                      formControlName="jobType" (selectionChange)="selectedJobType($event)"
                      [ngClass]="!classFlag ? 'breakPoint' : ''">
                      <mat-option value="all" class="option">All</mat-option>
                      @for (vendor of vendorCollections; track vendor) {
                        <mat-option value="{{ vendor }}" class="option">{{ vendor
                        }}</mat-option>
                      }
                    </mat-select>
                  </div>
                }
                @if (data === 'ActiveAssociates') {
                  <div class="col-sm-12 form-group"
                    [ngClass]="classFlag ? 'breakPoint' : ''">
                    <label name="role">Flag</label>
                    <mat-select disableRipple class="selectClass" formControlName="flag" placeholder="Select Flag"
                      (selectionChange)="flagChange($event)" [ngClass]="!classFlag ? 'breakPoint' : ''">
                      @for (flag of flagCollections; track flag) {
                        <mat-option value="{{ flag.value }}" class="option">{{ flag.type
                        }}</mat-option>
                      }
                    </mat-select>
                  </div>
                }
                @if (data == 'Seperate') {
                  <div class="col-sm-12">
                    <div class="form-group" [ngClass]="classFlag ? 'breakPoint' : ''">
                      <label name="role">Log Type</label>
                      <mat-select disableRipple placeholder="Select Log Type" class="selectClass" value="type.value"
                        formControlName="logType" [ngClass]="!classFlag ? 'breakPoint' : ''">
                        <mat-option value="all" class="option">All</mat-option>
                        @for (type of logTypes; track type) {
                          <mat-option value="{{ type.value }}" class="option">{{ type.type
                          }}</mat-option>
                        }
                      </mat-select>
                    </div>
                  </div>
                }
              </div>
              @if (dateSelected || data == 'History' || data == 'Seperate') {
                <div class="align-generate-btn button"
                  [ngClass]="!classFlag ? 'buttonClassFlag' : ''">
                  <button type="submit" class="create-action" [ngClass]="filterForm.valid ? 'hoverEffect' : ''"
                    [disabled]="filterForm.invalid">
                    <span>Generate</span>
                  </button>
                </div>
              }
            </form>
          }
        </div>
      </div>
    }
  </div>